import {
	Slider,
	type SliderProps,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";
import type { FC, ReactNode } from "react";
import { LabeledValueRow } from "web_myplann/Shared/Components/LabeledValueRow";

export type SliderRowProps = Pick<SliderProps, "min" | "max" | "step"> & {
	label: string;
	valueLabel: string;
	value: number;
	onChange: (value: number) => void;
	minLabel: string;
	maxLabel: string;
	icon?: ReactNode;
	disabled?: boolean;
	isLast?: boolean;
	isCompact?: boolean;
};

export const SliderRow: FC<SliderRowProps> = ({
	label,
	valueLabel,
	value,
	onChange,
	min,
	max,
	step,
	minLabel,
	maxLabel,
	icon,
	disabled,
	isLast,
	isCompact,
}) => {
	const theme = useTheme();

	return (
		<Stack
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			overflow={isCompact ? undefined : "hidden"}
			borderBottom={
				isLast
					? "none"
					: theme.colors.border.solid(theme.palette.surface.border)
			}
		>
			<LabeledValueRow
				label={
					<Stack
						direction="row"
						alignItems="center"
						gap={theme.spacingTokens.sm}
					>
						{icon}
						<Typography variant="bodyMedium">{label}</Typography>
					</Stack>
				}
				value={
					<Typography
						variant="bodyStrong"
						color={theme.palette.blue.main}
						tabular
					>
						{valueLabel}
					</Typography>
				}
			/>
			<Slider
				variant="flat"
				value={value}
				onChange={(_, next) =>
					onChange(typeof next === "number" ? next : next[0])
				}
				min={min}
				max={max}
				step={step}
				disabled={disabled}
				sx={isCompact ? undefined : { my: theme.spacingTokens.sm }}
			/>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="hint">{minLabel}</Typography>
				<Typography variant="hint">{maxLabel}</Typography>
			</Stack>
		</Stack>
	);
};
